<template>
  <h1
    class="text-center text-3xl tablet:text-4xl font-bold my-16 border-b-2 border-black p-2"
  >
    <slot />
  </h1>
</template>
